// extracted by css-extract-rspack-plugin
export default {"heading":"g5nM3z","text":"FI5tsU"};